import React, { useEffect, useMemo, useState } from 'react';
import './GoalModal.css';

const GoalModal = ({ currentGoal = 0, title = 'Edit Goal', onSave, onClose }) => {
  const [value, setValue] = useState(String(currentGoal ?? 0));
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setValue(String(currentGoal ?? 0));
  }, [currentGoal]);

  const numericValue = useMemo(() => {
    const parsed = Number(value);
    return Number.isFinite(parsed) && parsed >= 0 ? parsed : 0;
  }, [value]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!onSave) return;

    try {
      setSaving(true);
      await onSave(numericValue);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="goal-modal-overlay" onClick={onClose}>
      <div
        className="goal-modal-card"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="goal-modal-title"
      >
        <div className="goal-modal-header">
          <div>
            <p className="goal-modal-eyebrow">Agent Book CRM</p>
            <h2 id="goal-modal-title">{title}</h2>
            <p className="goal-modal-subtitle">
              Set the monthly target for this dashboard metric.
            </p>
          </div>

          <button
            type="button"
            className="goal-modal-close"
            onClick={onClose}
            aria-label="Close goal modal"
          >
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit} className="goal-modal-form">
          <div className="goal-input-block">
            <label htmlFor="goal-value">Monthly Goal</label>
            <input
              id="goal-value"
              type="number"
              min="0"
              step="1"
              value={value}
              onChange={(e) => setValue(e.target.value)}
              placeholder="Enter goal"
              autoFocus
            />
            <p className="goal-input-hint">
              This target will be used on the dashboard to track progress and pace.
            </p>
          </div>

          <div className="goal-preview-card">
            <span className="goal-preview-label">Preview Goal</span>
            <strong className="goal-preview-value">{numericValue}</strong>
          </div>

          <div className="goal-modal-actions">
            <button
              type="button"
              className="goal-btn-secondary"
              onClick={onClose}
              disabled={saving}
            >
              Cancel
            </button>

            <button
              type="submit"
              className="goal-btn-primary"
              disabled={saving}
            >
              {saving ? 'Saving...' : 'Save Goal'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default GoalModal;